export default {
  pid: 'Id de la publicación',
  username: 'Nombre del usuario',
  posted_at: 'Fecha original del documento',
  processed_at: 'Fecha de importación',
  post_url: 'Url de la publicación',
  openPostLabel: 'Abrir publicación',
  infoLabel: 'Información del Componente',
  closeLabel: 'Cerrar información',
  faq1: {
    title: '¿Qué es?',
    description: 'Componente con datos del historial de importación',
  },
  faq2: {
    title: '¿Qué datos tenemos disponibles?',
    description: 'Usuario que importó, fecha del documento, fecha de la importación y enlace del documento',
  },
  unavailableLink: 'Enlace no disponible',
  textToClipboard: 'Texto copiado al portapapeles.',
  failedClipboard: 'Error al copiar el texto.',
};
